
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { getintegral } from '@/api/user.js'
import { getClassify, getProductList } from '@/api/youzheng.js'
import { getSeckill, getProduct } from '@/api/mall.js'
import { getaddlog } from '@/api/hgfw'
import iconOrder from '@/assets/mall/mall-01.png'
import banner from '@/assets/mall/mall-02.png'
import config from '@/config'
import Scroll from '@/components/scroller'
import errorImg from '@/assets/mall/img-error.png'
import { getUserinfo } from '@/api/user'
import Storage from '@/storage'
export default {
name: 'mallIndex',
components: {
Flexbox,
FlexboxItem,
Tab,
TabItem,
Scroll
},
data () {
return {
prolist: 1,
timelist: [], // 时间段列表
spikeList: [], // 秒杀列表
iconOrder: iconOrder,
banner: banner,
owner_type: config.owner_type,
select: 0,
select2: 0,
getBarWidth: function (index) {
if (index === 0) {
return 30 + 'px'
} else {
return 60 + 'px'
}
},
vipname: this.$store.state.user.personObj.acctname,
integral: 0,
classifyList: [{
producttype: '',
producttypename: '全部'
}],
goodsList: [],
page: 1,
rows: 10,
baseUrl: config.baseUrl + '/',
producttype: '',
isshow: false,
notFirstLoad: false,
loadMoreDom: null,
errorImg: errorImg
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
producttype (newVal, oldVal) {
this.refresh()
},
prolist (newVal, oldVal) {
if (newVal == 2) {
this.loadMoreDom.style.display = 'none'
} else {
this.loadMoreDom.style.display = 'flex'
}
}
},
methods: {
getuser () {
console.log('123')
Storage.set('token', '')
getUserinfo({

userid: this.$store.state.user.userid
}).then(res => {
if (res.status === 'suc') {
if (!res.returnValue.userid) {
this.$vux.alert.show({
title: '请求出错',
content: '您不是该企业用户成员'
})
} else {
Storage.set('token', res.returnValue.token)
}
}
})
},
onImgError ($event) {
$event.target.src = this.errorImg
},
getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120103
}).then(res => {
})
},
ontab (index, producttype) {
this.select = index
this.producttype = producttype
},
ontab2 (index, id) {
this.select2 = index
this.getSpikelist(id)
},
getSpikelist (id) {
getProduct({ id: id }).then(data => {
this.spikeList = data.obj
})
},
getintegralTotal () {
/* 得到用户积分总信息 */
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue
})
},
gettype () {
getClassify().then(res => {
if (res.returnValue !== '' && res.returnValue.length > 0) {
res.returnValue.forEach((item, index) => {
this.classifyList.push({
producttype: item.producttype,
producttypename: item.producttypename
})
})
}
})
},
getlist (type, done) {
getProductList({
prodname: '',
usercredit: 0,
ordertype: 0,
grouptype: 0,
producttype: this.producttype,
isnew: 0,
page: this.page,
rows: this.rows,
orderdesc: ''
}).then(res => {
this.notFirstLoad = true
if (type === 'refresh' || type === 'search') {
this.goodsList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
res.returnValue.list.forEach(item => {
this.goodsList.push({
ID: item.ID,
PRODNAME: item.PRODNAME,
TITLEIMG: item.TITLEIMG,
CREDIT: item.CREDIT,
STARTDATE: item.STARTDATE,
AMOUNT: item.AMOUNT,
EXCHAGE: item.EXCHAGE,
GROUPTYPE: item.GROUPTYPE,
TIMELIMIT: item.TIMELIMIT,
PRICE: item.PRICE,
ispay: item.ispay,
saleprice: item.saleprice
})
})
}
if (res.returnValue.list.length === 0 || res.returnValue.count < this.rows) {
if (res.returnValue.count === 0) {
this.isshow = true
} else {
this.isshow = false
this.loadMoreDom.innerHTML = '<span style="display: none;">加载中……</span> <span>我也是有底线的～o～</span>'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
}
done && done()
}).catch(() => {
this.notFirstLoad = true
done && done()
})
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist('refresh', done)
},

loadMore (done) {
this.page++
this.loadMoreDom.innerHTML = '<span>加载中……</span><span style="display: none;">我也是有底线的～o～</span>'
this.getlist('more', done)
},
goMore (id) {
this.$router.push({ name: 'mall2ProductDetail', params: { id: id } })
},
lianxisj () {
this.$vux.alert.show({
content: '商家电话号码：0577-86162738'
})
},
getSeckill () {
getSeckill().then(res => {
this.timelist = res.obj
if (res.obj.length > 0) {
this.getSpikelist(res.obj[0].id)
}
})
}
},
activated () {
this.listDom.scrollTop = config.scrollPosition.y
},
beforeRouteLeave (to, from, next) {
config.scrollPosition.y = this.listDom.scrollTop
next()
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
this.getSeckill()
},
created () {
this.getAdd()
this.getintegralTotal()
this.gettype()
this.getlist()
}
}
